import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, switchMap, throwError, of } from 'rxjs';

import { AuthService } from '../services/auth.service';
import { RedirectService } from '../services/redirect.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private authService = inject(AuthService);
  private redirectService = inject(RedirectService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const accessToken = this.authService.getAccessToken();

    let authReq = req;

    if (accessToken) {
      authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
    }

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          const isAuthEndpoint = req.url.includes('/auth/login') || req.url.includes('/auth/refresh-session');
          
          if (isAuthEndpoint) {
            // Se è un endpoint di autenticazione che fallisce, logout immediato
            // Pulisci i token prima di fare redirect per evitare redirect alla dashboard
            this.authService.logout();
            return throwError(() => error);
          }

          // Per altri endpoint, prova a refreshare il token
          return this.authService.refreshAccessToken().pipe(
            switchMap((newToken) => {
              const retryReq = req.clone({
                setHeaders: { Authorization: `Bearer ${newToken}` },
              });
              return next.handle(retryReq);
            }),
            catchError((refreshError) => {
              // Se anche il refresh fallisce, logout e redirect
              // Pulisci i token prima di fare redirect per evitare redirect alla dashboard
              this.authService.logout();
              return throwError(() => refreshError);
            })
          );
        }
        return throwError(() => error);
      })
    );
  }
}
